module.exports = __webpack_public_path__ + "static/11-39e73eb78c7554df2dbbfec8142a6b50.jpg";